var _Object$defineProperty2 = require("@babel/runtime-corejs2/core-js/object/define-property");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime-corejs2/core-js/object/define-property", "@babel/runtime-corejs2/core-js/object/define-properties", "@babel/runtime-corejs2/core-js/object/get-own-property-descriptors", "@babel/runtime-corejs2/core-js/object/get-own-property-descriptor", "@babel/runtime-corejs2/core-js/object/get-own-property-symbols", "@babel/runtime-corejs2/core-js/object/keys", "@babel/runtime-corejs2/helpers/slicedToArray", "core-js/modules/es6.regexp.match", "@babel/runtime-corejs2/helpers/defineProperty", "lodash.pick"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime-corejs2/core-js/object/define-property"), require("@babel/runtime-corejs2/core-js/object/define-properties"), require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors"), require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor"), require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols"), require("@babel/runtime-corejs2/core-js/object/keys"), require("@babel/runtime-corejs2/helpers/slicedToArray"), require("core-js/modules/es6.regexp.match"), require("@babel/runtime-corejs2/helpers/defineProperty"), require("lodash.pick"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.defineProperty, global.defineProperties, global.getOwnPropertyDescriptors, global.getOwnPropertyDescriptor, global.getOwnPropertySymbols, global.keys, global.slicedToArray, global.es6Regexp, global.defineProperty, global.lodash);
    global.fromEmacImage = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _defineProperty2, _defineProperties, _getOwnPropertyDescriptors, _getOwnPropertyDescriptor, _getOwnPropertySymbols, _keys, _slicedToArray2, _es6Regexp, _defineProperty3, _lodash) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

  _Object$defineProperty2(_exports, "__esModule", {
    value: true
  });

  _exports.default = _exports.blurUrlToBlurImage = void 0;
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  _defineProperties = _interopRequireDefault(_defineProperties);
  _getOwnPropertyDescriptors = _interopRequireDefault(_getOwnPropertyDescriptors);
  _getOwnPropertyDescriptor = _interopRequireDefault(_getOwnPropertyDescriptor);
  _getOwnPropertySymbols = _interopRequireDefault(_getOwnPropertySymbols);
  _keys = _interopRequireDefault(_keys);
  _slicedToArray2 = _interopRequireDefault(_slicedToArray2);
  _defineProperty3 = _interopRequireDefault(_defineProperty3);
  _lodash = _interopRequireDefault(_lodash);

  function ownKeys(object, enumerableOnly) { var keys = (0, _keys.default)(object); if (_getOwnPropertySymbols.default) { var symbols = (0, _getOwnPropertySymbols.default)(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor.default)(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3.default)(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors.default) { (0, _defineProperties.default)(target, (0, _getOwnPropertyDescriptors.default)(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2.default)(target, key, (0, _getOwnPropertyDescriptor.default)(source, key)); }); } } return target; }

  var resolutionToAlternateResolution = function resolutionToAlternateResolution(resolution) {
    return _objectSpread(_objectSpread({}, resolution), {}, {
      height: resolution.h,
      width: resolution.w,
      imageSize: "".concat(resolution.w, "x").concat(resolution.h)
    });
  };

  var blurUrlToBlurImage = function blurUrlToBlurImage(blurUrl) {
    var matches = blurUrl.match(/\/(\d+)x(\d+)\//);

    if (!matches) {
      return {
        url: blurUrl
      };
    }

    var _matches = (0, _slicedToArray2.default)(matches, 3),
        w = _matches[1],
        h = _matches[2];

    return {
      imageSize: "".concat(w, "x").concat(h),
      height: h * 1,
      h: h * 1,
      width: w * 1,
      w: w * 1,
      url: blurUrl
    };
  };

  _exports.blurUrlToBlurImage = blurUrlToBlurImage;

  var _default = function _default(image) {
    return ['landscape', 'banner', 'square', 'portrait'].filter(function (format) {
      return image && !!image[format];
    }).map(function (format) {
      return _objectSpread(_objectSpread({
        format: format
      }, (0, _lodash.default)(image[format].resolutions[0], ['h', 'w', 'url'])), {}, {
        height: image[format].resolutions[0] && image[format].resolutions[0].h,
        width: image[format].resolutions[0] && image[format].resolutions[0].w,
        alternateResolutions: image[format].resolutions.map(resolutionToAlternateResolution),
        blurImages: image[format].blurUrl ? [blurUrlToBlurImage(image[format].blurUrl)] : []
      });
    });
  };

  _exports.default = _default;
});